import { render, staticRenderFns } from "./IdCard.vue?vue&type=template&id=00e79714&scoped=true&"
import script from "./IdCard.vue?vue&type=script&lang=js&"
export * from "./IdCard.vue?vue&type=script&lang=js&"
import style0 from "./IdCard.vue?vue&type=style&index=0&id=00e79714&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e79714",
  null
  
)

export default component.exports